module.exports = __webpack_public_path__ + "static/media/r366.58fbd203.jpg";